import { createFileRoute } from '@tanstack/react-router';
import { FeedbackEditor } from '@/features/support/FeedbackEditor';

export const Route = createFileRoute('/admin/feedback/$attemptId/$itemVersionId')({
  component: FeedbackRoute,
});

function FeedbackRoute() {
  const { attemptId, itemVersionId } = Route.useParams();
  return <FeedbackEditor attemptId={attemptId} itemVersionId={itemVersionId} />;
}
